import { CancelTwoTone } from "@mui/icons-material";
import { Box, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import "./CustomerDetail.css";
import { useDispatch } from "react-redux";
import { useRef } from "react";
import { useEffect } from "react";
import { CommonShortCutAction } from "../../Store/CommonShortCutsReducer";

const CustomerDetails = (props) => {
  const Divider = () => {
    return <hr style={{ margin: "10px 0", borderTop: "1px solid #ccc" }} />;
  };
  const dispatch = useDispatch();
  //shortcut key
  const closeRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "covLosDashboard",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "q") {
        closeRef.current.click();
      }
    }
  };
  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Tooltip title="Close(Ctrl+Q)">
          <IconButton
            aria-label="Close"
            color="primary"
            onClick={() => {
              props.setShowDetail(false);
            }}
            ref={closeRef}
          >
            <CancelTwoTone fontSize="large" />
          </IconButton>
        </Tooltip>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "18px" }}>
        <Paper sx={{ height: "100%" }}>
          <Box
            sx={{ padding: "8px 0px 0px 8px", borderLeft: "5px solid #009DD9" }}
          >
            <Typography
              sx={{ color: "#009DD9", fontSize: "16px", fontWeight: "500" }}
            >
              Basic Details
            </Typography>
            <Box sx={{ display: "flex", gap: "120px", padding: "12px" }}>
              <Box>
                <Typography className="customerTitle">
                  Applicant Name
                </Typography>
                <Typography className="customerContent">Naveen</Typography>
              </Box>
              <Divider />
              <Box>
                <Typography className="customerTitle">Customer ID</Typography>
                <Typography className="customerContent">Naveen01476</Typography>
              </Box>
              <Divider />
              <Box>
                <Typography className="customerTitle">Mobile Number</Typography>
                <Typography className="customerContent">9750208902</Typography>
              </Box>
              <Divider />
              <Box>
                <Typography className="customerTitle">Email</Typography>
                <Typography className="customerContent">
                  naveennsanthi@gmail.com
                </Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
        <Paper sx={{ height: "100%" }}>
          <Box
            sx={{ padding: "8px 0px 0px 8px", borderLeft: "5px solid #009DD9" }}
          >
            <Typography
              sx={{ color: "#009DD9", fontSize: "16px", fontWeight: "500" }}
            >
              Address
            </Typography>
            <Box sx={{ display: "flex", gap: "100px", padding: "12px" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography className="customerTitle">
                  Permanent Address
                </Typography>
              </Box>

              <Box>
                <Typography className="customerTitle">
                  Address Line 1
                </Typography>
                <Typography className="customerContent">
                  3rd John Street,Seaside Promenade
                </Typography>
              </Box>

              <Box>
                <Typography className="customerTitle">
                  Address Line 2
                </Typography>
                <Typography className="customerContent">
                  Abishegapakkam,605007 Ariyankuppam
                </Typography>
              </Box>

              <Box>
                <Typography className="customerTitle">City</Typography>
                <Typography className="customerContent">Puducherry</Typography>
              </Box>
              <Box>
                <Typography className="customerTitle">Pincode</Typography>
                <Typography className="customerContent">607402</Typography>
              </Box>
            </Box>
            <Box sx={{ display: "flex", gap: "100px", padding: "12px" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography className="customerTitle">
                  Temporary Address
                </Typography>
              </Box>

              <Box>
                <Typography className="customerTitle">
                  Address Line 1
                </Typography>
                <Typography className="customerContent">
                  3rd John Street,Seaside Promenade
                </Typography>
              </Box>

              <Box>
                <Typography className="customerTitle">
                  Address Line 2
                </Typography>
                <Typography className="customerContent">
                  Abishegapakkam,605007 Ariyankuppam
                </Typography>
              </Box>

              <Box>
                <Typography className="customerTitle">City</Typography>
                <Typography className="customerContent">Puducherry</Typography>
              </Box>
              <Box>
                <Typography className="customerTitle">Pincode</Typography>
                <Typography className="customerContent">607402</Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
        <Paper sx={{ height: "100%" }}>
          <Box
            sx={{ padding: "8px 0px 0px 8px", borderLeft: "5px solid #009DD9" }}
          >
            <Typography
              sx={{ color: "#009DD9", fontSize: "16px", fontWeight: "500" }}
            >
              Other Details
            </Typography>
            <Box sx={{ display: "flex", gap: "150px", padding: "12px" }}>
              <Box>
                <Typography className="customerTitle">Business Name</Typography>
                <Typography className="customerContent">
                  Fitness Centres
                </Typography>
              </Box>
              <Box>
                <Typography className="customerTitle">Locality</Typography>
                <Typography className="customerContent">Indian</Typography>
              </Box>

              <Box>
                <Typography className="customerTitle">
                  Preferred Language
                </Typography>
                <Typography className="customerContent">English</Typography>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
};
export default CustomerDetails;
